import { checkDatesBetween } from "../../util/dateFunction"
export default {
    namespaced: true,
    state: () => ({
        database: [{
            "File": "1",
            "Phase": "1",
            "Process": "1.1",
            "ProcessName": "Data and information diagnostics",
            "DataAnalysis": "16",
            "Date": "2021/01/15",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "2",
            "Phase": "1",
            "Process": "1.3",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/01/15",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "3",
            "Phase": "1",
            "Process": "1.3",
            "ProcessName": "Peer Review",
            "PeerReview": "1",
            "Date": "2021/01/16",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "4",
            "Phase": "1",
            "Process": "1.3",
            "ProcessName": "Peer Review",
            "PeerReview": "1",
            "Date": "2021/01/18",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "5",
            "Phase": "1",
            "Process": "1.2",
            "ProcessName": "Initial screening",
            "DataAnalysis": "12",
            "Date": "2021/01/19",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "6",
            "Phase": "1",
            "Process": "1.3",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/01/22",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "7",
            "Phase": "2",
            "Process": "2.1",
            "ProcessName": "Fracture Design",
            "DataAnalysis": "18",
            "Date": "2021/02/02",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "8",
            "Phase": "2",
            "Process": "2.2",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/02/04",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "9",
            "Phase": "2",
            "Process": "2.2",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/02/10",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "10",
            "Phase": "2",
            "Process": "2.2",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/02/15",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "11",
            "Phase": "2",
            "Process": "2.2",
            "ProcessName": "Peer Review",
            "PeerReview": "1",
            "Date": "2021/02/20",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "12",
            "Phase": "2",
            "Process": "2.3",
            "ProcessName": "Well candidates selection",
            "DataAnalysis": "18",
            "Date": "2021/02/23",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "13",
            "Phase": "2",
            "Process": "2.4",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/02/25",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "14",
            "Phase": "2",
            "Process": "2.4",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/02/27",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "15",
            "Phase": "2",
            "Process": "2.4",
            "ProcessName": "Peer Review",
            "PeerReview": "1",
            "Date": "2021/03/01",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "16",
            "Phase": "2",
            "Process": "2.5",
            "ProcessName": "Operational Plan",
            "DataAnalysis": "10",
            "Date": "2021/03/03",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "17",
            "Phase": "2",
            "Process": "2.6",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/03/04",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "18",
            "Phase": "2",
            "Process": "2.6",
            "ProcessName": "Peer Review",
            "PeerReview": "1",
            "Date": "2021/03/09",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "19",
            "Phase": "2",
            "Process": "2.7",
            "ProcessName": "Economic Evaluation",
            "DataAnalysis": "12",
            "Date": "2021/03/12",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "20",
            "Phase": "2",
            "Process": "2.8",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/03/13",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "21",
            "Phase": "2",
            "Process": "2.8",
            "ProcessName": "Peer Review",
            "PeerReview": "1",
            "Date": "2021/03/17",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "22",
            "Phase": "2",
            "Process": "2.8",
            "ProcessName": "Peer Review",
            "PeerReview": "1",
            "Date": "2021/03/20",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "23",
            "Phase": "2",
            "Process": "2.9",
            "ProcessName": "Company Selection",
            "DataAnalysis": "8",
            "Date": "2021/03/21",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "24",
            "Phase": "2",
            "Process": "2.10",
            "ProcessName": "Peer Review",
            "PeerReview": "2",
            "Date": "2021/03/22",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "25",
            "Phase": "3",
            "Process": "3.1",
            "ProcessName": "Monitoring remote operations",
            "DataAnalysis": "10",
            "Date": "2021/03/30",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "26",
            "Phase": "4",
            "Process": "4.1",
            "ProcessName": "Diagnosis of operation results",
            "DataAnalysis": "8",
            "Date": "2021/04/05",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "27",
            "Phase": "4",
            "Process": "4.2",
            "ProcessName": "Peer Review",
            "PeerReview": "4",
            "Date": "2021/04/07",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "28",
            "Phase": "5",
            "Process": "5.1",
            "ProcessName": "Lesson learned",
            "DataAnalysis": "4",
            "Date": "2021/04/12",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "29",
            "Phase": "5",
            "Process": "5.2",
            "ProcessName": "Peer Review",
            "PeerReview": "1",
            "Date": "2021/04/15",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "30",
            "Phase": "6",
            "Process": "6.1",
            "ProcessName": "Final Report Development",
            "DataAnalysis": "8",
            "Date": "2021/04/17",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        },
        {
            "File": "31",
            "Phase": "6",
            "Process": "6.2",
            "ProcessName": "Final Report and Peer Review",
            "PeerReview": "4",
            "Date": "2021/04/20",
            "Progress status": "100%",
            "User": "Adolfo V",
            "Consultant ": "Martin E"
        }
        ]
    }),
    mutations: {

    },
    actions: {

    },
    getters: {
        obtenerDatosporfecha: (state) => ({ fechaInicial = undefined, fechaFinal = undefined, phase = undefined, procces = "Phase", Peer = true, Data = true }) => {
            let filters;
            if (fechaFinal && fechaFinal) {
                filters = state.database.filter(item => {
                    return checkDatesBetween(fechaInicial, fechaFinal, item.Date)
                })
            }
            if (!filters) {
                filters = state.database
            }
            if (phase) {
                filters = filters.filter(item => item.Phase === phase)
            }

            let result = []
            filters.reduce((r, a) => {
                if (!r[a[procces]]) {
                    r[a[procces]] = { Phase: a[procces], DataAnalysis: 0, PeerReview: 0 };
                    result.push(r[a[procces]])
                }
                r[a[procces]].DataAnalysis += parseInt(a.DataAnalysis || 0)
                r[a[procces]].PeerReview += parseInt(a.PeerReview || 0)
                return r
            }, {})

            const Format = []
            if (Peer && !Data) {
                for (let index = 0; index < result.length; index++) {
                    let auxArray = [result[index].Phase, result[index].PeerReview]
                    Format.push(auxArray)
                }
            }
            if (!Peer && Data) {
                for (let index = 0; index < result.length; index++) {
                    let auxArray = [result[index].Phase, result[index].DataAnalysis]
                    Format.push(auxArray)
                }
            }
            if (Peer && Data) {
                for (let index = 0; index < result.length; index++) {
                    let auxArray = [result[index].Phase, result[index].DataAnalysis + result[index].PeerReview]
                    Format.push(auxArray)
                }
            }
            return Format
        },
        getMinMaxDates: (state) => {
            let dates = state.database.map(item => new Date(item.Date))

            let latest = new Date(Math.max.apply(null, dates));
            let earliest = new Date(Math.min.apply(null, dates));

            let maxDate = new Date(latest)
            maxDate.setDate(maxDate.getDate() + 1)
            maxDate = maxDate.toISOString().substr(0, 10)

            let minDate = new Date(earliest)
            minDate.setDate(minDate.getDate() - 1)
            minDate = minDate.toISOString().substr(0, 10)

            return { maxDate, minDate }
        }
    }
}